import $ from 'jquery';
import debounce from 'lodash/debounce';
import { breakpoints } from "../utils";

export default class {
  constructor(el) {
    const self = this;
    self.$el = $(el);
    self.state = null;
    self.resize = debounce(self.resize.bind(self), 250);
    self.colors = ["#cacaca", "#9b9b9b", "#c2332b"];
    $(window).on("resize", self.resize).trigger("resize");
  }
  resize() {
    const self = this;
    $(".c-line").remove();
    if($(window).width() < breakpoints.desktop && self.state !== "mobile") {
      self.state = "mobile";
    } else if($(window).width() >= breakpoints.desktop && self.state !== "desktop") {
      self.state = "desktop";
    }
    if(self.state === "desktop"){
      // How many viewports
      var scrollHeight = document.body.scrollHeight;
      var viewportHeight = $(window).height();
      var viewportWidth = $(window).width();
      var halfMargin = (viewportWidth - breakpoints.desktop) / 4;
      var numberOfViewports = Math.floor(scrollHeight / viewportHeight);

      for (var i = 0; i < numberOfViewports; i++) {
        for (var j = 0; j < 4; j++) {
          $('<div class="c-line"/>')
            .appendTo('body')
            .css({
              "top": i*viewportHeight + (0.1 + Math.random()*0.8)*j/4*viewportHeight,
              "left": Math.random()*0.5*halfMargin,
              "width": (0.5 + Math.random()*0.5)*halfMargin,
              "border-bottom": '2px solid ' + self.colors[Math.ceil(Math.random()*3)],
              "animation-delay": Math.random()*3 + 's',
              "animation-duration": 2 + Math.random()*5 + 's',
            })
          $('<div class="c-line c-line--right"/>')
            .appendTo('body')
            .css({
              "backgroundColor": self.colors[Math.ceil(Math.random()*3)],
              "top": i*viewportHeight + (0.1 + Math.random()*0.8)*j/4*viewportHeight,
              "right": Math.random()*0.5*halfMargin,
              "width": (0.5 + Math.random()*0.5)*halfMargin,
              "animation-delay": Math.random()*3 + 's',
              "animation-duration": 2 + Math.random()*5 + 's',
            })
        }
      }

    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Lines.js